module.exports = __webpack_public_path__ + "static/media/bar-code.ea14802f.svg";